type PluralForms = {
  one: string
  few: string
  many: string
}

/**
 * Picks the Polish form that goes with a count: one book, two books, five books.
 *
 * Lives in shared rather than in the app because the backend writes numbers into
 * user-facing messages too - a refusal that reads "1 aktywnych kampanii" is the
 * kind of sentence a person notices before they notice what it is telling them.
 */
export function pluralizePl(count: number, forms: PluralForms): string {
  if (count === 1) {
    return forms.one
  }

  const lastDigit = count % 10
  const lastTwoDigits = count % 100

  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    return forms.few
  }

  return forms.many
}
